export default function appendFormFields(data: Object, form: HTMLFormElement): void {
    for (const [key, value] of Object.entries(data)) {
        const inputHidden: HTMLInputElement = document.createElement('input');

        inputHidden.type = 'hidden';
        inputHidden.name = key;
        inputHidden.value = value;

        form.appendChild(inputHidden);
    }
}
